import type { QueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";
import { PrivatesAppointmentsApi } from "@/openapi/generated";

export async function prefetchAppointmentAvailabilityGet(
  appointmentId: number,
  queryClient: QueryClient,
  accessToken?: string,
) {
  if (!accessToken) {
    throw new Error(
      "Access token is required for prefetching appointment availability",
    );
  }

  const service = createAuthenticatedApi(PrivatesAppointmentsApi, accessToken);

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.AppointmentAvailability, appointmentId],
    queryFn: () =>
      service.apiAppointmentsIdAvailabilityGet({
        id: appointmentId,
      }),
    staleTime: 2 * 60 * 1000,
  });

  return queryClient;
}
